import { useMemo } from 'react';

import { usePayrollHiddenPayoutMethodsQuery } from 'store/api/payroll';

// Owner 27 Oct 2026: a rep is never paid with a car rental vendor's Direct
// Billing method. Ops reads them from the QuickBooks rental lane's reviewed
// role rows (QbAccountMappings payment_method_role "direct_billing:<group>:
// payment_method:<id>", LEGACY_CREDIT excluded; GET mailer/payroll/
// payout-methods/hidden): by id, never by name, whatever the lane's switch.
// While that read fails the set is empty and the lists are today's.
// Payments already made with such a method keep showing it: history reads
// the payout's own method, not these lists.
export const useRentalBillingMethodIds = (): ReadonlySet<number> => {
  const read = usePayrollHiddenPayoutMethodsQuery();
  const ids = read.isError ? undefined : read.data?.paymentMethodIds;
  return useMemo(
    () =>
      new Set(
        (ids ?? [])
          .map(Number)
          .filter((id) => Number.isSafeInteger(id) && id > 0)
      ),
    [ids]
  );
};
